<div>
  <h3>UW Performance as of {{today}}</h3>

  <div class="col-12">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Rank</th>
          <th>Underwriter</th>
          <th>Loan Interviews</th>
          <th>Approved</th>
          <th>Declined</th>
          <th>File Review</th>
          <th>Checklist</th>
          <th>Calls</th>
          <th>Total Talk Time</th>
          <th>Avg Talk Time</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let uw of uws">
          <td>{{uw.rank}}</td>
          <td>{{uw.underwriter}}</td>
          <td>{{uw.loanInterviewCount}}</td>
          <td>{{uw.approved}}</td>
          <td>{{uw.declined}}</td>
          <td>{{uw.fileReview}}</td>
          <td>{{uw.checklist}}</td>
          <td>{{uw.call}}</td>
          <td>{{uw.totalTalkTime}}</td>
          <td>{{uw.avgTalkTime}}</td>
        </tr>
        <tr>
          <td class="total" colspan="2">Totals</td>
          <td>{{uwTotal.loanInterviewCount}}</td>
          <td>{{uwTotal.approved}}</td>
          <td>{{uwTotal.declined}}</td>
          <td>{{uwTotal.fileReview}}</td>
          <td>{{uwTotal.checklist}}</td>
          <td>{{uwTotal.call}}</td>
          <td>{{uwTotal.totalTalkTime}}</td>
          <td>{{uwTotal.avgTalkTime}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>